import React, { useContext, useEffect, useRef, useState } from "react";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toolbar } from "primereact/toolbar";
import { UserDelimitation } from "./users/UserDelimitation";
import { mohaService } from "../services/MohaService";
import { AppDB } from "../App";
import { Badge } from "primereact/badge";
import { Checkbox } from "primereact/checkbox";
import { formatDate, formatDateTime } from "../config/Config";

function processFile(file) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();

		reader.onloadend = function () {
			const base64String = reader.result.split(',')[1]; // Get the base64 string without the data URL prefix
			resolve(base64String);
		};

		reader.onerror = function () {
			reject(new Error('File reading failed.'));
		};

		// Read the file as a Data URL (base64 encoded)
		reader.readAsDataURL(file);
	});
}
export const MohaFile = () => {
	var { toast } = useContext(AppDB);

	var [loading, setLoading] = useState(true);
	var [allDemacartion, setAllDemacartion] = useState(false);
	var [selectedBatch, setSelectedBatch] = useState({});
	
	var fileRef = useRef(null);
	var [batchData, setBatchData] = useState([]);
	var [batchIDsData, setBatchIDsData] = useState([]);
	var [showMohaDialog, setShowMohaDialog] = useState(false);
	var [showMohaIDsDialog, setShowMohaIDsDialog] = useState({ show: false, heading: "", mohaBatchID: null });
	var [refresh, setRefresh] = useState(false);
	const [totalRecords, setTotalRecords] = useState([]);
	const [delimitation, setDelimitation] = useState({ delimitationID: "", delimitationLevelID: "" });

	const [lazyState, setlazyState] = useState({
		first: 0,
		rows: 10,
		page: 0,
		search: ""
	});

	const onPageChange = (event) => {
		setlazyState(event);
	};



	const create_batch = () => {
		setLoading(true)
		mohaService.create_batch(allDemacartion ? {} : delimitation).then(res => {
			if (res.success) {
				setRefresh(!refresh)
				setShowMohaDialog(false)
				toast.show({
					severity: "success",
					detail: "Batch Created",
					life: 6000
				});
			} else {
				toast.show({
					severity: "error",
					detail: res.message,
					life: 6000
				});
			}
			setLoading(false)
		})
	};


	const batch_get_file = (batchID,referenceNumber,delimitationName) => {
		setLoading(true)
		mohaService.get_batch_file(batchID).then(res => {
			setRefresh(!refresh)
			downloadCSV(res,referenceNumber,delimitationName)
			setLoading(false)
		})
	};

	const upload_batch_file = async (batchID, f,referenceNumber) => {

		var file = await processFile(f);
		setLoading(true)

        // Convert Blob/File to text using FileReader
        const text = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsText(f); // <-- Reads it as text
        });
        const lines = text.trim().split("\n");

        if (lines.length <= 1) {
			toast.show({
				severity: "error",
				detail: `CSV file must contain at least one data row.`,
				life: 6000
			});
			return;
        }

        const header = lines[0].split(",").map(h => h.trim());
        const idIndex = header.indexOf("IDNumber");
        const statusIndex = header.indexOf("Status");

        if (idIndex === -1 || statusIndex === -1) {
			toast.show({
				severity: "error",
				detail: `CSV header must include 'IDNumber' and 'Status'.`,
				life: 6000
			});
			return;			
        }

        // Validate each data row
        for (let i = 1; i < lines.length; i++) {
            const row = lines[i].split(",");
            const id = row[idIndex]?.trim();
            const status = row[statusIndex]?.trim();

            if (!id || !status) {
				toast.show({
					severity: "error",
					detail: `Upload failed. One or more records are missing a Status. Please correct the file and try again.`,
					life: 6000
				});
				return;
            }
        }

        setLoading(true);

		mohaService.upload_batch_file(selectedBatch.mohaBatchID, file).then(res => {
			setLoading(true)

			if (res.success) {
				setRefresh(!refresh)
				toast.show({
					severity: "success",
					detail: `Batch file, reference number '${selectedBatch.referenceNumber}' uploaded`,
					life: 6000
				});
			} else {
				toast.show({
					severity: "error",
					detail: res.message,
					life: 6000
				});
			}
		})
		// setShowMohaIDsDialog({...showMohaIDsDialog,show:true,heading:row.referenceNumber});

	};


	useEffect(() => {
		var params = {
			pageIndex: 1,
			pageSize: lazyState.rows * (lazyState.page + 1),
		};

		setLoading(true);

		mohaService.get_batch_list(params.pageIndex, params.pageSize).then((res) => {
			console.log(res.batches)
			setTotalRecords(res.count);
			// res?.batches.reverse()
			setBatchData(res?.batches || []);
			setLoading(false);
		});

	}, [lazyState, refresh]);


	useEffect(() => {
		if (showMohaIDsDialog.mohaBatchID !== null) {
			setLoading(true)
			mohaService.get_batch_ids_list(showMohaIDsDialog.mohaBatchID).then(res => {
				setLoading(false)
				setBatchIDsData(res.records)
			})
		}

	}, [showMohaIDsDialog])

	
	useEffect(() => {
		const interval = setInterval(() => {
		  // Check if any item has status "processing" set to true
		  const isProcessing = batchData.some(item => item?.processed !== true);
		  
		  // If there is at least one processing, refresh the state
		  if (isProcessing && loading===false) {
			setRefresh(prev => !prev);
		  } else {
			// If no items are processing, clear the interval to stop refreshing
			clearInterval(interval);
		  }
		}, 10000); // 10 seconds interval
	
		// Cleanup interval on component unmount or when the condition is met
		return () => clearInterval(interval);
	  }, [batchData,loading]); // Dependency array makes sure this runs when 'items' state changes




	function downloadCSV(text,referenceNumber,delimitationName) {
		// Convert array of objects to CSV string


		const today = new Date();
		const dateStr = today.toISOString().replaceAll('T', "--"); // 'YYYY-MM-DD' format

		// Create the file name with the current date
		const filename = `${referenceNumber}${delimitationName}.csv`;
		// Create a Blob with CSV data and create a download link
		const blob = new Blob([text], { type: 'text/csv' });
		const link = document.createElement('a');
		link.href = URL.createObjectURL(blob);
		link.download = filename;

		// Trigger the download by simulating a click event
		link.click();
	}



	return (
		<div className="grid">
			<div className="col-12">
				<div className="card">
					<h5>MOHA File</h5>
					<div className="">
						<Toolbar
							className="mb-4"
							left={<>
								<Button className="p-button-success ml-4" label="Create" onClick={() => {

									setShowMohaDialog(true)
								}} />

								<Button loading={loading} className="ml-4" label="Refresh" onClick={() => {
									setRefresh(!refresh)
								}} />

							</>}
						// right={
						// 	<div className="flex">
						// 		<DropDown
						// 			type="search"
						// 			placeholder="Search"
						// 			value={searchValue}
						// 			optionLabel={"name"}
						// 			optionValue={"name"}
						// 			options={options}
						// 			onChange={(e) => setSearchValue(e.value)}
						// 			style={{ width: "280px" }}
						// 		/>


						// 	</div>
						// }
						></Toolbar>
					</div>
					<Dialog
						header={<h5>Create MOHA Batch</h5>}
						style={{ maxWidth: 900, width: "95%" }}
						visible={showMohaDialog}
						onHide={() => setShowMohaDialog(false)}
						footer={<>
							<Button className="p-button-success ml-4" label="Submit" onClick={() => {
								create_batch()
							}} />

						</>}
					>

						<div className="mt-4 mb-3" >
							<Checkbox onChange={e => setAllDemacartion(e.checked)} checked={allDemacartion}></Checkbox>
							<span className="ml-3"><b>All Demarcations</b></span>
						</div>
						<br />
						{!allDemacartion && (<UserDelimitation
							forceFilter={true}
							showVillage={true}
							isReport={false}
							// showFilter={reportInfo.selectedReport?.isNationalElectionReport}
							onDelimitationChanged={(delimitation) => setDelimitation(delimitation)}
						/>)}
					</Dialog>

					<Dialog
						header={<h5>MOHA List</h5>}
						style={{ maxWidth: 900, width: "95%" }}
						visible={showMohaIDsDialog.show}
						onHide={() => setShowMohaIDsDialog({ ...showMohaIDsDialog, show: false })}

					>
						<DataTable
							first={lazyState.first}
							size="small"
							value={batchIDsData}
							loading={loading}
							scrollable={true}
							emptyMessage="No data found."
							resizableColumns
							columnResizeMode="expand"
							rows={lazyState.rows}
							rowsPerPageOptions={[10, 20, 50]}
							// totalRecords={totalRecords}
							// onPage={onPageChange}
							paginator={true}

						>

							<Column field="idNumber" header="ID  Number" style={{ width: "250px" }}></Column>
							<Column field="received" header="Received" body={row => <>

								{row.received ? <Badge severity="success" value={'Yes'} /> : <Badge severity="info" value={'No'} />}

							</>} style={{ width: "250px" }}></Column>
							<Column field="status" header="Status" style={{ width: "250px" }}></Column>
						</DataTable>
					</Dialog>

					<DataTable
						first={lazyState.first}
						size="small"
						value={batchData}
						loading={loading}
						scrollable={true}
						emptyMessage="No data found."
						resizableColumns
						columnResizeMode="expand"
						rows={lazyState.rows}
						rowsPerPageOptions={[10, 20, 50]}
						totalRecords={totalRecords}
						onPage={onPageChange}
						paginator={true}
					>
						<Column field="referenceNumber" header="Reference Number" style={{ width: "100px" }}></Column>
						<Column field="noOfRecords" style={{ width: "50px" }} header="No Of Records" body={row => <>
							{row?.processed !== true ?
								<i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
								: row?.noOfRecords
							}
						</>}></Column>
						<Column header="Demarcation" style={{ width: "150px" }} body={row => <>
							{row.delimitation === null ? "All" : row.delimitation}
						</>}></Column>

						<Column header="Demarcation Name" body={row => <>
							{row.delimitationLevelID === 5 && <>
								{row.delimitationName === null ? "" : <span>{row.delimitationCode} - </span>}
							</>}
							{row.delimitationName === null ? "All" : row.delimitationName}
						</>}></Column>

						<Column header="Created Date" sortable body={row => <>
							{formatDateTime(row.createdDate)}
						</>}></Column>


						<Column field="createdBy" header="CreatedBy"></Column>
						<Column
							field="Action"
							header="Action"
							body={(row) => (
								<>
									<Button
										style={{ textAlign: "center", width: "30px", height: "30px" }}
										icon={"pi pi-eye"}
										className="p-button-primary p-button-rounded mr-2 "
										tooltip="Click to View"
										onClick={() => {
											setShowMohaIDsDialog({ ...showMohaIDsDialog, mohaBatchID: row.mohaBatchID, show: true })
										}}
									/>
									<Button
										disabled={[row?.processed !== true, row?.noOfRecords===0].includes(true) }
										style={{ textAlign: "center", width: "30px", height: "30px" }}
										icon={"pi pi-download"}
										className="p-button-primary p-button-rounded mr-2 "
										tooltip="Click to Download"
										onClick={() => {
											batch_get_file(row.mohaBatchID,row.referenceNumber,(row.delimitationName === null ? "" : '-'+row.delimitationName))
										}}
									/>
									<input onChange={(e) => {
										upload_batch_file(row.mohaBatchID, e.target.files[0],row.referenceNumber)
									}} ref={fileRef} type="file" style={{ display: "none" }} />
									<Button
										disabled={  [row?.processed !== true, row?.noOfRecords===0, row?.uploaded===true].includes(true) }
										style={{ textAlign: "center", width: "30px", height: "30px" }}
										icon={"pi pi-upload"}
										className="p-button-primary p-button-rounded mr-2 "
										tooltip="Click to Upload"
										onClick={() => {
											fileRef.current.value = "";  // This clears the file input
											fileRef.current.click()
											setSelectedBatch(row)

										}}
									/>
								</>
							)}
						></Column>

					</DataTable>
				</div>
			</div>
		</div>
	);
};
